/* global frameworkScreenReaderText */

// IE10 in Windows Phone 8 Fix
// Fixes device width vs viewport width issue to apply media queries in Bootstrap's CSS.
// Copyright 2014-2017 The Bootstrap Authors
// Copyright 2014-2017 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

// DeBounce Function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

(function( $ ) {
	// Variables and DOM Caching.
	var $html = $('html'),
		$body = $( 'body' ),
		// $entryContent = $body.find( '.entry-content' ),
		$formatQuote = $body.find( '.format-quote blockquote' ),
        $window = $(window),
        // $wpVideo = $('#wp-custom-header-video'),
        // For videos, remove the YouTube embedded background video, if set.
		$allVideos = $("iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com'], iframe[src*='https://www.youtube-nocookie.com'], object, embed, .content-area iframe").not('.wp-custom-header *'),
        newWidth,
        $el;

	// Initialize parallax helper script
	if ($html.hasClass('parallax-enabled')) {
		document.addEventListener('DOMContentLoaded', function() {
			initializeParallax(document.querySelector('.viewport'));
	    });
	}

	// Fix for displaying side controls on <select> elements in Android stock browser
	var nua = navigator.userAgent
	var isAndroid = nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1
	if (isAndroid) {
		$('select.form-control').removeClass('form-control').css('width', '100%')
	}


	// IE & Edge fallback for object-fit.
	if ( ! Modernizr.objectfit ) {
		$('.hero-banner, .custom-hero-banner').each(function() {
			var $container = $(this).children('.hero-image'),
				$imgUrl = $container.find('img').prop('src');

			if ($imgUrl) {
				$container
				.css('background-image', 'url(' + $imgUrl + ')')
				.addClass('compat-object-fit');
			}
		});


		$('.objectfit-container').each(function() {
			var $container = $(this).children('.objectfit-img'),
				$imgUrl = $container.find('img').prop('src');

			if ($imgUrl) {
				$container
				.css('background-image', 'url(' + $imgUrl + ')')
				.addClass('compat-object-fit');
			}
		});

		// Set heights for the content in IE 11 (Runs in Edge as a precaution, but only IE 11 should need this fallback)
		var setExplicitHeight = function() {
			$('.content-block > .container > .row').each(function() {
				$(this).height($(this).find('.content-wrap').height());
			});
		}

	    var setExplicitHeightResize = debounce(setExplicitHeight, 250);

	    $window.resize(setExplicitHeightResize).resize();
	}

    // Fix for Carousels that resolves Google Chrome issues with hover on pause.
    $('.carousel').hover(function () {
        $(this).carousel('pause')
    }, function () {
        $(this).carousel('cycle')
    })

	// Set icon for quotes.
	function setQuotesIcon() {
		$( frameworkScreenReaderText.quote ).prependTo( $formatQuote );
	}

	// Add 'below-entry-meta' class to elements.
    /*
	function belowEntryMetaClass( param ) {
		var sidebarPos, sidebarPosBottom;

		if ( ! $body.hasClass( 'has-sidebar' ) || (
			$body.hasClass( 'search' ) ||
			$body.hasClass( 'single-attachment' ) ||
			$body.hasClass( 'error404' ) ||
			$body.hasClass( 'framework-front-page' )
		) ) {
			return;
		}

		sidebarPos       = $sidebar.offset();
		sidebarPosBottom = sidebarPos.top + ( $sidebar.height() + 28 );

		$entryContent.find( param ).each( function() {
			var $element = $( this ),
				elementPos = $element.offset(),
				elementPosTop = elementPos.top;

			// Add 'below-entry-meta' to elements below the entry meta.
			if ( elementPosTop > sidebarPosBottom ) {
				$element.addClass( 'below-entry-meta' );
			} else {
				$element.removeClass( 'below-entry-meta' );
			}
		});
	}
    */

	/*
	 * Test if inline SVGs are supported.
	 * @link https://github.com/Modernizr/Modernizr/
	 */
	function supportsInlineSVG() {
		var div = document.createElement( 'div' );
		div.innerHTML = '<svg/>';
		return 'http://www.w3.org/2000/svg' === ( 'undefined' !== typeof SVGRect && div.firstChild && div.firstChild.namespaceURI );
	}

	/**
	 * Test if an iOS device.
	*/
	function checkiOS() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) && ! window.MSStream;
	}

	/*
	 * Test if background-attachment: fixed is supported.
	 * @link http://stackoverflow.com/questions/14115080/detect-support-for-background-attachment-fixed
	 */
	function supportsFixedBackground() {
		var el = document.createElement('div'),
			isSupported;

		try {
			if ( ! ( 'backgroundAttachment' in el.style ) || checkiOS() ) {
				return false;
			}
			el.style.backgroundAttachment = 'fixed';
			isSupported = ( 'fixed' === el.style.backgroundAttachment );
			return isSupported;
		}
		catch (e) {
			return false;
		}
	}

	// Fire on document ready.
	$( document ).ready( function() {
		setQuotesIcon();
		if ( true === supportsInlineSVG() ) {
			document.documentElement.className = document.documentElement.className.replace( /(\s*)no-svg(\s*)/, '$1svg$2' );
		}

		if ( true === supportsFixedBackground() ) {
			document.documentElement.className += ' background-fixed';
		}
	});

	// Add header video class after the video is loaded.
	$( document ).on( 'wp-custom-header-video-loaded', function() {
		$body.addClass( 'has-header-video' );
	});

    // Responsive video resizing.
	// var $allVideos, newWidth, $el;
    if ($allVideos.length) {
        $allVideos.each(function() {
            // jQuery .data does not work on object/embed elements
            $(this).attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
        });

        var videoResize = function() {
            $allVideos.each(function() {
                $el = $(this);  // Automatically detects parent element and resizes according to its dimensions.
                newWidth = $el.parent().width();
                $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
            });
        }

        // Run first call to the videos.
        videoResize();

        var windowResize = debounce(videoResize, 250);

        $window.resize(windowResize);
    }


	// Background Video Resize - Derived from Tubular, broken down due to YouTube API called via WordPress
    // http://www.seanmccambridge.com/tubular/
    // This functions because global.js & custom.js are loaded after wp_footer().

	// resize handler updates width, height and offset of player after resize/init
	// All calls associated with the background iframe video are moved into the resizer due
	// to issues with lag time on Safari
	var videoBackgroundResize = function() {
		var $wpPlayer = $('iframe#wp-custom-header-video');

		if (typeof $wpPlayer.attr('data-aspectRatio') == "undefined") {
		    $wpPlayer.attr('data-aspectRatio', $wpPlayer.attr('width') / $wpPlayer.attr('height')).removeAttr('height').removeAttr('width');
		}

		var width = $window.width(),
			pWidth,
			height = $window.height(),
			pHeight,
			ratio = $wpPlayer.attr('data-aspectRatio');

		if (width / ratio < height) {
			pWidth = Math.ceil(height * ratio);
			$wpPlayer.width(pWidth).height(height);
		} else {
			pHeight = Math.ceil(width / ratio);
			$wpPlayer.width(width).height(pHeight);
		}
	}

    var windowBackgroundResize = debounce(videoBackgroundResize, 250);

	function onPlayerStateChange(event) {
		if (event.data == YT.PlayerState.PLAYING) {
			$body.addClass('hero-yt-playing');
			YT.get('wp-custom-header-video').removeEventListener('onStateChange', onPlayerStateChange);
		}
	}

	var checkYT = setInterval(function() {
		// Check for Youtube API
		if ( 'YT' in window ) {
			// If YT is loaded, trigger the video resize script
			if (YT.loaded) {
				clearInterval(checkYT);

				YT.get('wp-custom-header-video').addEventListener('onStateChange', onPlayerStateChange);
				$window.resize(windowBackgroundResize).resize();
			}
		} else {
			// If the YoutTube API is not loaded, but video is still found, resize the HTML video
			if ($('#wp-custom-header-video').length) {
				clearInterval(checkYT);
				$window.resize(windowBackgroundResize).resize();
			} else {
				// If video still isn't found, then check if video is even set.
				if (!$('.hero-video').length) {
					// If not, bail out.
					clearInterval(checkYT);
				}
			}
		}
	}, 100);


    // Add swipe functionality to all Bootstrap Carousels
    // To future proof, only apply to Carousels that use the .swipe class (in case of other animations).
    var wrap = $('.carousel.slide');

    // Only run the swipe code if a carousel is found.
    // The swipe.js files are enqueued and registerd if a Carousel section is loaded.
    // If Carousel is statically or custom added somewhere, be sure that the files are enqueued properly.
    if (wrap.length) {
        wrap.each(function() {
            var slider = $(this),
                width = slider.width(),
        	    slides = slider.find('.carousel-item'),
                sliding = false,
                // slideHeight = 0,
                timer;

            slider.on('slide.bs.carousel', function () {
                if (typeof timer !== "undefined") {
                    clearTimeout(timer);
                }
                sliding = true;
            }).on('slid.bs.carousel', function() {
                sliding = false;
            });

        	// Listen for swipe events on slides, and hook into Bootstrap Carousel
            // Only fire events if the carousel is at a standstill.
            // This prevents odd functionality or swiping while the carousel is transitioning.
        	slides.on('swipeleft', function() {
                if ($(this).next('.carousel-item')) {
                    $(this).next('.carousel-item').trigger('activate');
                }
        	}).on('swiperight', function() {
                if ($(this).prev('.carousel-item')) {
                    $(this).prev('.carousel-item').trigger('activate');
                }
        	}).on('activate', function() {
                if (!sliding) {
                    slider.carousel(slides.index($(this)));
                }
            }).on('movestart', function(e) {
        		// If the movestart heads off in a upwards or downwards
        		// direction, prevent it so that the browser scrolls normally.
        		if ((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) {
        			e.preventDefault();
        			//return;
        		}

        		// To allow the slide to keep step with the finger,
        		// temporarily disable transitions.
                //slides.removeClass('carousel-item-prev carousel-item-next');

                if (!sliding) {
            		slider.addClass('notransition').carousel('pause');

                    // If we start attempting to slide, clear the timeout to avoid any flash.
                    if (typeof timer !== "undefined"){
                        clearTimeout(timer);
                    }
                }
        	}).on('move', function(e) {
                if (!sliding) {
            		var left = 100 * e.distX / width;

            		// Move slides with the finger
            		if (e.distX < 0) {
                        if ($(this).next('.carousel-item').length != 0) {
                            $(this).css({
                                '-webkit-transform': 'translate3d(' + left + '%,0,0)',
                                'transform': 'translate3d(' + left + '%,0,0)'
                            });
                            $(this).next('.carousel-item').addClass('carousel-item-next').css({
                                '-webkit-transform': 'translate3d(' + (left+100) + '%,0,0)',
                                'transform': 'translate3d(' + (left+100) + '%,0,0)'
                            });
                        } else {
                            $(this).css({
                                '-webkit-transform': 'translate3d(' + (left/4) + '%,0,0)',
                                'transform': 'translate3d(' + (left/4) + '%,0,0)'
                            });
                        }
            		}
            		if (e.distX > 0) {
                        if ($(this).prev('.carousel-item').length != 0) {
                            $(this).css({
                                '-webkit-transform': 'translate3d(' + left + '%,0,0)',
                                'transform': 'translate3d(' + left + '%,0,0)'
                            });
                            $(this).prev('.carousel-item').addClass('carousel-item-prev').css({
                                '-webkit-transform': 'translate3d(' + (left-100) + '%,0,0)',
                                'transform': 'translate3d(' + (left-100) + '%,0,0)'
                            });
                        } else {
                            $(this).css({
                                '-webkit-transform': 'translate3d(' + (left/5) + '%,0,0)',
                                'transform': 'translate3d(' + (left/5) + '%,0,0)'
                            });
                        }
            		}
                }
        	}).on('moveend', function() {
        		slider.removeClass('notransition').carousel('cycle');

                $(this).css({
                    '-webkit-transform': '',
                    'transform': ''
                });

        		if ($(this).next('.carousel-item')) {
                    $(this).next('.carousel-item').css({
                        '-webkit-transform': '',
                        'transform': ''
                    });
        		}
        		if ($(this).prev('.carousel-item')) {
                    $(this).prev('.carousel-item').css({
                        '-webkit-transform': '',
                        'transform': ''
                    });
        		}

                // Remove the positioning classes whether slides succeeded or failed.
                // Set to an amount slower than the slide transitions but shorter than the carousel timeout.
                timer = setTimeout(function() {
                    slides.removeClass('carousel-item-prev carousel-item-next');
                }, 800);
        	});
        });
    }


    var modals = $body.find('[data-overlay]'),
        modalTriggers = $('.modal-trigger'),
        // modalVideoTriggers = $('.modal-trigger[data-video="true"]'),
        modalClosers = modals.find('.modal-close, .modal-close-alt, .modal-inner'),
        modalContent = $('.modal-body');

    modalTriggers.each(function() {
        var modal = modals.filter('.modal-overlay[data-overlay="' + $(this).data('overlay') + '"]'),
            modalVideo = modal.find('.video-wrap iframe').detach();

        $(this).click(function(event) {
            event.preventDefault();
            event.stopPropagation();

            modal.toggleClass('modal-open');
			$body.toggleClass('modal-active');

            if ($(this).data('video')) {
                if (modal.hasClass('modal-open')) {
                    modalVideo.appendTo('.video-wrap');

            		var $element = modalVideo;  // Automatically detects parent element and resizes according to its dimensions.
            		var $newWidth = $element.parent().width();
            		$element.width($newWidth).height($newWidth * $element.attr('data-aspectRatio'));
                } else {
                    modalVideo = modalVideo.detach();
                }
            }
        });
    });

    modalContent.click(function(event) {
        event.stopPropagation();
    });

    modalClosers.click(function() {
        modals.removeClass('modal-open');
		$body.removeClass('modal-active');

        if ($(this).parents('.modal-overlay').hasClass('video')) {
            $('.video-wrap').empty();
        }
    });


    // Initialize calls for various navigation systems.
    var	$viewport	  = $('.viewport'),
		$navbar       = $('.navbar'),
		$navGlobal    = $('.nav-global'),
        $navPanel     = $('.menu-panel'),
		$navPillars	  = $('.nav-pillars'),
		$navFullStack = $('.menu-panel.full-stack'),
    	$navGlobalItems = $('.nav.nav-global').find('*'),
		$navToggle	  = $('.menu-toggle, .sub-menu-toggle');

	if ($navbar.length) {
		$navbar.find('.navbar-toggler').click(function(e) {
			e.preventDefault();

        	$navGlobalItems.removeClass('active');

            if ($navPanel.length) {
                $navPanel.toggleClass('active');
            } else {
    			$navGlobal.toggleClass('active');
            }

			$body.toggleClass('menu-open');

			if ($html.hasClass('parallax-enabled')) {
				$viewport.scrollTop(0);
			}
		});
	}

	if ($navPillars.length) {
		$navPillars.find('.sub-menu, .sub-menu-container').each(function() {
			var $th = $(this);

			$(this).prev('a').click(function(e) {
				e.preventDefault();

				$th.addClass('active');
				$body.addClass('menu-open');
			});
		});

		// IE & Edge fallback for object-fit.
		if ( ! Modernizr.objectfit ) {
			$navPillars.find('.sub-menu .nav-item').each(function() {
				var $container = $(this).children('.nav-link'),
					$imgUrl = $container.find('.menu-item-bg').prop('src');

				if ($imgUrl) {
					$container
					.css('background-image', 'url(' + $imgUrl + ')')
					.addClass('compat-object-fit');
				}
			});
		}
	}

    if ($navFullStack.length) {
        var $navSubMenus = $navFullStack.find('.sub-menu');
		$navSubMenus.each(function() {
			var $th = $(this);

			$(this).prev('a').click(function(e) {
				e.preventDefault();

                if ($th.hasClass('active')) {
                    $th.removeClass('active');
                } else {
                    $navSubMenus.removeClass('active');
    				$th.addClass('active');
                }
			});
		});
    }

	if ($navToggle.length) {
		$navToggle.click(function() {

			$navGlobalItems.removeClass('active');

            if ($navPanel.length) {
                $navPanel.removeClass('active');
            } else {
    			$navGlobal.removeClass('active');
            }

			$body.removeClass('menu-open');
		});
	}

})( jQuery );
